import {
  ON_FILTER_CONSIGNER_OPTION_SELECT, ON_FILTER_MONTH_OPTION_SELECT, FETCH_SALES_REPORT, FETCH_SALES_REPORT_SUCCESS,
  FETCH_CONSIGNER_OPTIONS, FETCH_CONSIGNER_OPTIONS_SUCCESS, FETCH_MONTH_OPTIONS, FETCH_MONTH_OPTIONS_SUCCESS,
  ON_SHOW_LOADER, ON_HIDE_LOADER, FETCH_SAVED_REPORTS, FETCH_SAVED_REPORTS_SUCCESS
} from "../constants/ActionTypes";

export const onFilterConsignerOptionSelect = option => {
  return {
    type: ON_FILTER_CONSIGNER_OPTION_SELECT,
    payload: option
  };
};
export const onFilterMonthOptionSelect = option => {
  return {
    type: ON_FILTER_MONTH_OPTION_SELECT,
    payload: option
  };
};
export const fetchSalesReport = (data) => {
  return {
    type: FETCH_SALES_REPORT,
    payload: data
  };
};
export const fetchSalesReportSuccess = data => {
  return {
    type: FETCH_SALES_REPORT_SUCCESS,
    payload: data
  };
};
export const fetchConsignerOptions = () => {
  return {
    type: FETCH_CONSIGNER_OPTIONS
  };
};
export const fetchConsignerOptionsSuccess = entities => {
  return {
    type: FETCH_CONSIGNER_OPTIONS_SUCCESS,
    payload: entities
  };
};
export const fetchMonthOptions = () => {
  return {
    type: FETCH_MONTH_OPTIONS
  };
};
export const fetchMonthOptionsSuccess = entities => {
  return {
    type: FETCH_MONTH_OPTIONS_SUCCESS,
    payload: entities
  };
};
export const fetchSavedReports = (data) => {
  return {
    type: FETCH_SAVED_REPORTS,
    payload: data
  };
};
export const fetchSavedReportsSuccess = data => {
  return {
    type: FETCH_SAVED_REPORTS_SUCCESS,
    payload: data
  };
};



export const showReportLoader = () => {
  return {
      type: ON_SHOW_LOADER,
  };
};
export const hideReportLoader = () => {
  return {
      type: ON_HIDE_LOADER,
  };
};

